// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root__3723A","review":"styles__review__3oJGi","reviewInfoContainer":"styles__reviewInfoContainer__12nl2","reviewInfo":"styles__reviewInfo__Np4yd","reviewAuthor":"styles__reviewAuthor__2_XLh","reviewDate":"styles__reviewDate__3SDoj","reviewRatingStar":"styles__reviewRatingStar__9QBwX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewCard/styles.css
// module id = 2149
// module chunks = 0